import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContextMenuItem = _resolveComponent("ContextMenuItem")!
  const _component_ContextMenu = _resolveComponent("ContextMenu")!

  return (_openBlock(), _createBlock(_component_ContextMenu, {
    isVisible: _ctx.isVisible,
    position: _ctx.position,
    onClose: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      (!_ctx.isFlatTree)
        ? (_openBlock(), _createBlock(_component_ContextMenuItem, {
            key: 0,
            onClick: _ctx.handleGlobalExpandAll
          }, {
            default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
              _createTextVNode("Развернуть все", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isFlatTree)
        ? (_openBlock(), _createBlock(_component_ContextMenuItem, {
            key: 1,
            onClick: _ctx.handleGlobalCollapseAll
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode("Свернуть все", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      (!_ctx.isSingleMode)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleGlobalSelectAll }, {
              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                _createTextVNode("Выбрать все", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleGlobalUnselectAll }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                _createTextVNode("Снять все", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            (!_ctx.isFlatTree)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.additionalMenu, (item) => {
                  return (_openBlock(), _createBlock(_component_ContextMenuItem, {
                    key: item.label,
                    onClick: item.action
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              : _createCommentVNode("", true),
            (_ctx.isShowChildrenActions)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleLocalSelectAllChildrenByLevel }, {
                    default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                      _createTextVNode("Отметить подчиненные по уровню", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleLocalSelectAllChildren }, {
                    default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                      _createTextVNode("Отметить все подчиненные", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ContextMenuItem, { onClick: _ctx.handleLocalUnselectAllChildren }, {
                    default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                      _createTextVNode("Снять отметку с подчиненных", -1)
                    ]))]),
                    _: 1
                  }, 8, ["onClick"])
                ], 64))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["isVisible", "position", "onClose"]))
}